import { defineMessages } from 'react-intl';

export default defineMessages({
  policyNumber: {
    id: 'search_bar.policy_number',
  },
  registrationNumber: {
    id: 'search_bar.registration_number',
  },
  lossDate: {
    id: 'search_bar.loss_date',
  },
  preOpenDate: {
    id: 'claims.opening_date',
  },
  claimNumber: {
    id: 'search_bar.claim_number',
  },
  policy: {
    id: 'search_bar.search_form_type_policy_number',
  },
  register: {
    id: 'search_bar.search_form_type_register_number',
  },
  claim: {
    id: 'search_bar.search_form_type_claim_number',
  },
  defaultLawyerAssignment: {
    id: 'search_bar.search_form_type_default_lawyer_assignment',
  },
  procedureType: {
    id: 'search_bar.search_form_label_procedure_type',
  },
  assuredCIN: {
    id: 'search_bar.search_form_label_assured_CIN',
  },
  assuredName: {
    id: 'search_bar.search_form_label_assured_name',
  },
  victimName: {
    id: 'search_bar.search_form_label_victim_name',
  },
  courtFileNumber: {
    id: 'search_bar.search_form_label_court_file_number',
  },
  procedureNature: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.procedure.title',
  },
  juridictionDegree: {
    id: 'civil_proceeding_modal.percentage_juridiction',
  },
  juridiction: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  selectProcedureType: {
    id: 'select.procedure_type',
  },
  courtFileNumberError: {
    id: 'legal_proceeding_page.number_field.error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  cin_assure: {
    id: 'search_bar.search_form_type_cin_assure',
  },
  full_name_assure: {
    id: 'search_bar.search_form_type_full_name_assure',
  },
  ref_attestation: {
    id: 'search_bar.search_form_type_ref_attestation',
  },
});
